import React, {Component} from "react";
import Table from "../../components/Table";
import DeliveryItem from "./DeliveryItem";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {connect} from "react-redux";
import {graphql} from "react-apollo";
import {
  requestViewSubscriptionDelivery
} from "../../actions/AccountApiActions";
import gql from "graphql-tag";

class DeliveryList extends Component {

  UNSAFE_componentWillMount() {
    this.subscribe(this.props.subscriptionId); 
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.subscriptionId && (prevProps.subscriptionId !== this.props.subscriptionId)) {
      this.subscribe(this.props);
    }
  }

  componentWillUnmount() {
    this.unsubscribe(); 
  }    

  subscribe(subscriptionId) {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToMore(this.props, {});
  } 

  render() {
    let {loading, error, subscriptionDeliveries} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let tableHeader = List([
      "Delivery Id",
      "Recipient",
      "Qty",
      "Destination",
      "Warehouse",
      "Prep Date",
      "Delivery",
      "Status",
      ""
    ])          
    return (
      <Table 
        data={fromJS(subscriptionDeliveries)} 
        renderer={DeliveryItem} 
        onItemClick={this.handleItemClick.bind(this)}
        onContextMenuClick={this.handleContextMenu.bind(this)}
        tableHeader={tableHeader}
        extraClassName="DeliveryList"
        itemKey="deliveryId"
        mode="table"
        showCount={true}
        selected={this.props.selectedId}
        />
    )
  }

  handleItemClick(itemData, e, field = "") {
    let id = itemData.get("deliveryId");
    let accountId = itemData.get("accountId");
    if (field === "id") {
      e.stopPropagation();
      this.props.onIdClick(id, accountId);
      return;
    }    
    this.props.onSelectionChange(id);
  }  

  handleContextMenu(data, x, y) {
    this.props.requestViewSubscriptionDelivery(data.get("deliveryId"));
  }
}


const DELIVERIES = gql`
  query subscriptionDeliveries($filter:SubscriptionDeliveryFilterInput) {
    subscriptionDeliveries(filter: $filter) {
      deliveryId
      accountId
      warehouseId
      status
      stockStatus
      scheduleStatus
      requestedDeliveryDate
      deliveryDate
      prepDate
      shippingAddress {
        name
        addressStateProvince
        addressCity
        addressCountryCode
      }
      products {
        quantity
      }
    }
  }
`;

const ON_UPDATED_SUBSCRIPTION_DELIVERIES = gql`
  subscription onUpdatedSubscriptionDeliveries($subscriptionId:ID!) {
    updatedSubscriptionDeliveries(subscriptionId: $subscriptionId) {
      subscriptionId
    }
  }
`;

const withQuery = graphql(DELIVERIES, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        subscriptionId: props.subscriptionId,
        shopId: props.shopFilter,
        status: props.statusFilter,
        dateRange: props.dateFilter,
        warehouseId: props.warehouseFilter,
        usDistributionWarehouseId: props.distributionFilter
      }
    }
  })
})

const mapDispatchToProps = dispatch => ({
  subscribeToMore: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_SUBSCRIPTION_DELIVERIES,
      variables: {
        subscriptionId: props.subscriptionId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  },
  requestViewSubscriptionDelivery: (...args) => dispatch(requestViewSubscriptionDelivery(...args))
})


export default connect(null, mapDispatchToProps)(withQuery(DeliveryList));